import styles from './Error.module.less'
import TelusLogo from '../../../assets/icons/telus-logo.svg'
import { useEffect } from 'react'

export type ErrorPageProps = {
    text1: string
    text2?: string
    errorSVG: string
    btnTitle: string
    onClick: () => void
}

export const ErrorPage: React.FC<ErrorPageProps> = (props: ErrorPageProps) => {
    useEffect(() => {
        // document.title = PAGE_TITLES.HOME
    }, [])

    return (
        <div className={styles['root']}>
            <div className={styles['header']}>
                <img className={styles['logo']} src={TelusLogo} alt="Telus International Logo" />
                <span className={styles['title']}>Experts Engine</span>
            </div>
            <div className={styles['main']}>
                <img src={props.errorSVG} alt="Error SVG File" />
                <span className={styles['text-1']}>{props.text1}</span>
                <span className={styles['text-2']}>{props.text2}</span>
                <button className={styles['button']} onClick={props.onClick}>
                    {props.btnTitle}
                </button>
            </div>
        </div>
    )
}
